import React, { useEffect } from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useModal } from "../hooks/useModal";

export default function DontEnable({ enable, dont_enable }) {
  const [enabled, setEnabled] = React.useState(false);
  const { closeModal, view } = useModal();
  useEffect(() => {
    if (enabled) dont_enable();
    else enable();
  }, [closeModal]);

  useEffect(() => {
    setEnabled(false);
  }, [view]);
  return (
    <div className="w-[96%] md:w-[402px] mx-auto bg-background dark:bg-[#2A2C30] p-[32px] rounded-[8px] shadow-lg">
      <div className="flex flex-col gap-[41px] text-center">
        <div className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Don't Enable?
          </Text>
          <Text className="font-switzer text-[14px] text-[#758599] font-[400]">
            Not reloading your wallet when it goes down will cause your campaign
            to pause
          </Text>
        </div>
        <div className="flex gap-[18px] justify-center">
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-[#F2F2F2]"
            onClick={() => {
              setEnabled(false);
              closeModal();
            }}
          >
            <Text className="font-[400] text-[12px] text-[#191919] font-switzer">
              Cancel
            </Text>
          </ActionIcon>
          <ActionIcon
            className="w-[109px] h-[35px] rounded-[4px] !bg-btn"
            onClick={() => {
              setEnabled(true);
              closeModal();
            }}
          >
            <Text className="font-[400] text-[12px] text-background font-switzer">
              Don't Enable
            </Text>
          </ActionIcon>
        </div>
      </div>
    </div>
  );
}
